import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=43de9f4f&scoped=true&"
import script from "./RecommendList.vue?vue&type=script&lang=js&"
export * from "./RecommendList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=43de9f4f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de9f4f",
  null
  
)

export default component.exports